<template>
    <div>
        <!-- Table Data -->
        <div>
            <vs-table id="manager-list" class="vs-con-loading__container" stripe :sst="true" maxHeight="800px"
                @change-page="handleChangePage" @sort="handleSort" :total="managerFilteredCount" :max-items="length"
                :data="managerRecords">
                <template slot="header">
                    <!-- Per Page Record -->
                    <div class="mb-2 flex items-center">
                        <div class="flex flex-wrap justify-between items-center">
                            <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                                <vs-dropdown vs-trigger-click class="cursor-pointer filter-font">
                                    <div
                                        class="p-4 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                                        <span class="mr-2">
                                            {{ page * length - (length - (managerFilteredCount && 1)) || 0 }}
                                            -
                                            {{ managerFilteredCount - page * length > 0 ? page * length :
                                                managerFilteredCount }}
                                            of {{ managerTotal || 0 }}
                                        </span>
                                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                                    </div>
                                    <vs-dropdown-menu>
                                        <vs-dropdown-item @click="handleChangeLength(10)">
                                            <span>10</span>
                                        </vs-dropdown-item>
                                        <vs-dropdown-item @click="handleChangeLength(20)">
                                            <span>20</span>
                                        </vs-dropdown-item>
                                        <vs-dropdown-item @click="handleChangeLength(50)">
                                            <span>50</span>
                                        </vs-dropdown-item>
                                        <vs-dropdown-item @click="handleChangeLength(100)">
                                            <span>100</span>
                                        </vs-dropdown-item>
                                    </vs-dropdown-menu>
                                </vs-dropdown>
                            </div>
                        </div>
                        <div v-if="!isHotelManager" @click.stop="inviteMember()"
                            class="btn-add-new p-2 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-primary border border-solid border-primary">
                            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                            <span class="ml-2 text-base text-primary">Add {{ module_name }}</span>
                        </div>
                    </div>
                </template>

                <!-- Table Header -->
                <template slot="thead">
                    <vs-th>Sr#</vs-th>
                    <vs-th>Email</vs-th>
                    <vs-th>Mobile Number</vs-th>
                    <vs-th>Handle Name</vs-th>
                    <vs-th v-if="!isHotelManager">Action</vs-th>
                </template>

                <!-- Table Data Display -->
                <template slot-scope="{ data }">
                    <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
                        <vs-td>
                            {{ page * length - (length - i - 1) }}
                        </vs-td>
                        <vs-td class="text-left">
                            <span>{{ tr.manager_access_email || tr.email || '-' }}</span>
                        </vs-td>
                        <vs-td class="text-left">
                            <span>{{ tr.mobile || '-' }}</span>
                        </vs-td>
                        <vs-td class="text-left">
                            <span>{{ tr.handle_name || '-' }}</span>
                        </vs-td>
                        <vs-td v-if="!isHotelManager">
                            <div class="inline-flex">
                                <vx-tooltip :text="`${module_name} Access Revoke`">
                                    <feather-icon @click.stop="revokeAccess(tr._id, `${tr.email}`)" icon="UserXIcon"
                                        svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" />
                                </vx-tooltip>
                            </div>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
            <!-- Custom Pagination -->
            <vs-pagination v-if="managerFilteredCount" v-model="page" :total="totalPages"
                :max="totalPages / length > 7 ? 7 : 5" class="mt-8"></vs-pagination>
        </div>
        <vs-popup button-accept="false" button-cancel="false" :active.sync="popupActive"
            :title="`Invite Hotel Manager`">
            <div class="vx-row px-5 vs-con-loading__container">
                <div class="vx-col px-0 w-full">
                    <!-- Loop through email, mobile, and handle name inputs -->
                    <div v-for="(entry, index) in form.email" :key="index" class="mt-2 mb-3">
                        <label :for="'Email-' + index">Email {{ index + 1 }}</label>
                        <div class="flex justify-between flex-wrap">
                            <!-- Email Input -->
                            <div class="w-full mb-2">
                                <vs-input :id="'Email-' + index" class="w-full" v-model="entry.email"
                                    v-validate="'required|email'" :name="'Email-' + index" icon="icon icon-mail"
                                    icon-pack="feather" placeholder="Please add Email" data-vv-as="Email"
                                    @input="debouncedLookupByEmail(entry, index)" />
                                <span class="text-danger text-sm" v-show="errors.has('Email-' + index)">
                                    {{ errors.first('Email-' + index) }}
                                </span>
                            </div>

                            <!-- Mobile Input -->
                            <div class="w-full mb-2">
                                <vs-input :id="'Mobile-' + index" class="w-full" v-model="entry.mobile"
                                    @input="debouncedCheckMobile(entry.mobile, index)" v-validate="'required|numeric'"
                                    :name="'Mobile-' + index" icon="icon icon-smartphone" icon-pack="feather"
                                    placeholder="Please add Mobile Number" data-vv-as="Mobile" />
                                <span class="text-danger text-sm" v-show="errors.has('Mobile-' + index)">
                                    {{ errors.first('Mobile-' + index) }}
                                </span>
                            </div>

                            <!-- Handle Name Input -->
                            <div class="w-full">
                                <vs-input :id="'Handle-' + index" class="w-full" v-model="entry.handle_name"
                                    v-validate="'required'" :name="'Handle-' + index" icon="icon icon-user" disabled
                                    icon-pack="feather" placeholder="Please add Handle Name" data-vv-as="Handle Name" />
                                <span class="text-danger text-sm" v-show="errors.has('Handle-' + index)">
                                    {{ errors.first('Handle-' + index) }}
                                </span>
                            </div>

                            <!-- Remove Button -->
                            <div class="w-full flex justify-end mt-2">
                                <vx-tooltip :text="`Remove`">
                                    <vs-button @click="removeEmail(index)" color="danger" type="gradient"
                                        icon-pack="feather" icon="icon-trash-2" />
                                </vx-tooltip>
                            </div>
                        </div>
                    </div>

                    <!-- Add Email Button -->
                    <div class="mt-3 mb-3 flex justify-start">
                        <vx-tooltip :text="`Add Email`">
                            <vs-button @click="addEmail" color="success" type="gradient" icon-pack="feather"
                                icon="icon-plus" />
                        </vx-tooltip>
                    </div>

                    <!-- Action Buttons -->
                    <div class="mt-4">
                        <div class="w-full px-0 justify-items-center">
                            <vs-button class="text-sm py-3 px-5" color="dark" @click.stop="popupActive = false"> Cancel
                            </vs-button>
                            <vs-button
                                class="ml-2 vs-con-loading__container text-sm vs-component vs-button vs-button-primary vs-button-filled py-3 px-5"
                                id="invite-hotel-manager" @click.stop="inviteManagerAction">
                                Invite
                            </vs-button>
                        </div>
                    </div>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'HotelManager',

  data: () => ({
    length: 10,
    page: 1,
    search: '',
    form: {
      email: [{ email: '', mobile: '', handle_name: '' }],
      hotel: ''
    },
    module_name: 'Hotel Manager',
    popupActive: false,
    breadcrumb: []
  }),

  computed: {
    ...mapState('hotel', ['managerRecords', 'managerTotal', 'managerFilteredCount', 'managerListLoading', 'createManagerLoading', 'record']),
    totalPages() {
      return Math.ceil(this.managerFilteredCount / this.length)
    },
    isHotelManager() {
      const userInfo = this.$store.state.auth.userInfo
      return userInfo && userInfo.role && userInfo.role.slug === 'hotel-manager'
    }
  },

  methods: {
    ...mapActions('hotel', {
      get: 'getHotelManagers',
      inviteManager: 'inviteHotelManager',
      revokeAccessUser: 'revokeHotelManagerAccess',
      showHotel: 'show'
    }),
    ...mapActions('gurudwara', {
      getHandleNameByMobile: 'getHandleNameByMobile'
    }),

    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },

    handleChangePage(page) {
      this.page = page
      this.getData()
    },

    handleSort() {
      this.getData()
    },

    getData() {
      this.get({
        hotelId: this.$route.params.hotelId,
        limit: this.length,
        page: this.page,
        search: this.search
      })
    },

    inviteMember() {
      this.popupActive = !this.popupActive
    },

    addEmail() {
      this.form.email.push({ email: '', mobile: '', handle_name: '' })
    },

    removeEmail(index) {
      if (this.form.email.length <= 1) return
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Delete`,
        text: `Are you sure you want to remove this entry?`,
        accept: () => {
          this.form.email.splice(index, 1)
        },
        acceptText: 'Remove'
      })
    },

    revokeAccess(userId, name) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Access Revoke`,
        text: `Are you sure you want to remove access for '${name}'?`,
        accept: () => this.revokeAccessById(userId),
        acceptText: 'Revoke Access'
      })
    },

    async revokeAccessById(userId) {
      try {
        const { message } = await this.revokeAccessUser({ hotelId: this.$route.params.hotelId, userId })
        this.$vs.notify({
          title: 'Success',
          text: message,
          color: 'success'
        })
        this.getData()
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.message || 'Failed to revoke access',
          color: 'danger'
        })
      }
    },

    async inviteManagerAction() {
      if (!(await this.$validator.validate())) {
        return
      }

      try {
        const { message } = await this.inviteManager(this.form)
        this.form.email = [{ email: '', mobile: '', handle_name: '' }]
        this.$vs.notify({
          title: 'Success',
          text: message,
          color: 'success'
        })
        this.popupActive = false
        this.getData()
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.message || 'Failed to invite manager',
          color: 'danger'
        })
      }
    },

    // Debounced wrapper for mobile lookup
    debouncedCheckMobile(mobile, index) {
      clearTimeout(this._mobileTimer)
      this._mobileTimer = setTimeout(() => {
        this.checkMobileLength(mobile, index)
      }, 500)
    },

    checkMobileLength(mobile, index) {
      if (!mobile) {
        this.form.email[index].handle_name = ''
        return
      }
      // Trigger auto-detection for 7+ digits for international support
      if (mobile.length >= 7) {
        this.fetchHandleName(mobile, index)
      }
    },

    // Debounced wrapper for email lookup
    debouncedLookupByEmail(entry, index) {
      clearTimeout(this._emailTimer)
      this._emailTimer = setTimeout(() => {
        this.lookupByEmail(entry.email, index)
      }, 600)
    },

    async lookupByEmail(email, index) {
      if (!email || !email.includes('@')) return
      try {
        // Backend service is now updated to handle email lookup as well
        const response = await this.getHandleNameByMobile(email)
        if (response && response.data) {
          if (response.data.handle_name) {
            this.form.email[index].handle_name = response.data.handle_name
          }
          if (response.data.mobile_number && !this.form.email[index].mobile) {
            this.form.email[index].mobile = response.data.mobile_number
          }
        }
      } catch (err) {
        // Silent catch
      }
    },

    async fetchHandleName(mobile, index) {
      try {
        const response = await this.getHandleNameByMobile(mobile)
        if (response && response.data) {
          this.form.email[index].handle_name = response.data.handle_name
          if (response.data.email) {
            this.form.email[index].email = response.data.email
          }
        }
      } catch (err) {
        console.error('Failed to fetch handle name:', err)
      }
    }
  },

  watch: {
    breadcrumb(newvalue) {
      this.$emit('update-breadcrumb', newvalue)
    },
    managerListLoading(val) {
      if (val) {
        this.$vs.loading({ container: '#manager-list', scale: 0.45 })
      } else {
        this.$vs.loading.close('#manager-list > .con-vs-loading')
      }
    },
    createManagerLoading(val) {
      if (val) {
        this.$vs.loading({ container: '#invite-hotel-manager', scale: 0.45 })
      } else {
        this.$vs.loading.close('#invite-hotel-manager > .con-vs-loading')
      }
    },
    page() {
      this.getData()
    }
  },

  async mounted() {
    this.form.hotel = this.$route.params.hotelId
    this.getData()

    const hotelId = this.$route.params.hotelId
    const gurudwaraId = this.$route.params.gurudwaraId

    if (hotelId) {
      try {
        const res = await this.showHotel(hotelId)
        const data = res.data
        if (gurudwaraId) {
          this.breadcrumb = [
            { title: 'Dashboard', url: '/dashboard' },
            { title: 'Gurudwara', url: '/gurudwara/list' },
            { title: data.name, active: true },
            { title: 'Hotel Managers', active: true }
          ]
        } else {
          this.breadcrumb = [
            { title: 'Dashboard', url: '/dashboard' },
            { title: 'Hotel', url: '/hotel/list' },
            { title: data.name, active: true },
            { title: 'Hotel Managers', active: true }
          ]
        }
      } catch (error) {
        console.error('Error fetching hotel details for breadcrumb:', error)
      }
    }
  }
}
</script>
